import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@platform/core/lib/format';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { sinceParts } from './sinceParts';

/** Відносний час мовою інтерфейсу як у прототипі v4: «щойно», «12 хв тому», «3 год тому», «5 дн. тому», давніше — «28 жовт.». */
export function useSince(): (iso: string) => string {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  return useCallback((iso: string) => {
    const { unit, count } = sinceParts(Date.parse(iso), Date.now());
    if (unit === 'date') return formatDate(iso, lang);
    return unit === 'now' ? t('notifText.justNow') : t(`notifText.${unit}Ago`, { count });
  }, [t, lang]);
}
